export const MESSAGES = {
  SUCCESS: {
    GENERATION_COMPLETE: 'Prompts generated successfully!',
    COPIED_TO_CLIPBOARD: (section) => `${section} copied to clipboard!`,
    DOWNLOADED: (filename) => `Downloaded ${filename}`,
    FORM_RESET: 'Form has been reset',
  },

  ERROR: {
    GENERATION_FAILED: 'Failed to generate prompts. Please try again.',
    API_ERROR: (message) => `API Error: ${message}`,
    NETWORK_ERROR: 'Network error. Please check your connection.',
    TIMEOUT_ERROR: 'Request timed out. The model may be overloaded.',
    UNKNOWN_ERROR: 'An unexpected error occurred',
    COPY_FAILED: 'Failed to copy to clipboard',
    DESCRIPTION_REQUIRED: 'Description is required',
    DESCRIPTION_TOO_SHORT: (min) => `Description must be at least ${min} characters`,
    DESCRIPTION_TOO_LONG: (max) => `Description must not exceed ${max} characters`,
    
    USE_CASE_REQUIRED: 'Use case is required',
    USE_CASE_TOO_SHORT: (min) => `Use case must be at least ${min} characters`,
    USE_CASE_TOO_LONG: (max) => `Use case must not exceed ${max} characters`,
    
    SCHEMA_REQUIRED: 'Schema is required when output type is Schema',
    SCHEMA_INVALID_JSON: 'Schema must be valid JSON',
    SCHEMA_TOO_LONG: (max) => `Schema must not exceed ${max} characters`,
    
    VARIABLE_NAME_INVALID: 'Variable name must be alphanumeric (letters, numbers, underscores)',
    VARIABLE_NAME_TOO_LONG: (max) => `Variable name must not exceed ${max} characters`,
    VARIABLE_DESCRIPTION_TOO_LONG: (max) => `Variable description must not exceed ${max} characters`,
    
    MAX_VARIABLES_REACHED: (max) => `Maximum ${max} variables allowed`,
  },

  INFO: {
    LOADING: 'Generating prompts...',
    LOADING_LONG: 'This may take up to 2 minutes...',
    NO_OUTPUT: 'No prompts generated yet',
    EMPTY_VARIABLES: 'No variables added yet',
  },

  PLACEHOLDER: {
    DESCRIPTION: 'Describe what you want to generate... e.g., "Create a prompt for generating product descriptions"',
    USE_CASE: 'Describe the specific use case... e.g., "E-commerce product catalog with SEO optimization"',
    SCHEMA: 'Enter your JSON schema... e.g., {"type": "object", "properties": {...}}',
    VARIABLE_NAME: 'Variable name (e.g., product_name)',
    VARIABLE_DESCRIPTION: 'Description (e.g., The name of the product)',
  },

  LABEL: {
    MODEL: 'AI Model',
    DESCRIPTION: 'Description',
    USE_CASE: 'Use Case',
    CONVERSATION_TYPE: 'Conversation Type',
    OUTPUT_FORMAT: 'Output Format',
    SCHEMA: 'JSON Schema',
    VARIABLES: 'Input Variables',
    SYSTEM_PROMPT: 'System Prompt',
    USER_PROMPT: 'User Prompt',
  },

  BUTTON: {
    GENERATE: 'Generate Prompts',
    GENERATING: 'Generating...',
    RESET: 'Reset',
    COPY: 'Copy',
    COPIED: 'Copied',
    DOWNLOAD: 'Save',
    DOWNLOAD_ALL: 'Download All',
    ADD_VARIABLE: '+ Add Variable',
    REMOVE: 'Remove',
  },
};

export default MESSAGES;

